import React, { useEffect, useState } from "react";
import { API_URL } from "../../utils/ApiUrl";
import TaskTimer from "./TaskTimer";
import Timer from "../landing/LatestTask/Timer";
import { Link, useParams } from "react-router-dom";
import Environment from "../../utils/Environment";

import Button from "react-bootstrap/Button";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import SimilarTasksStatus from "./SimilarTasksStatus";
import TaskStatus from "../../helperFunction/TaskStatus";
import { getStatus } from "../../helperFunction/status";
import { intitial_production_eth_id } from "../../constants/id";

function SimilarTasks({ taskId, categoryId, handleShow, category }) {
  const [tasks, setTasks] = useState([]);
  const [userId, setUserId] = useState(0);
  const { id } = useParams(); // Get the task ID from the URL

  const getTasks = async ({
    limit = 5,
    offset = 1,
    categoryId = null,
    orderField = "createdAt",
    orderDirection = "ASC",
  } = {}) => {
    const accessToken = localStorage.getItem("accessToken");

    // Construct query parameters
    const queryParams = new URLSearchParams({
      limit,
      offset,
      orderField,
      orderDirection,
    });

    if (categoryId) {
      queryParams.append("categoryId", categoryId); // Only include if categoryId is provided
    }

    try {
      const response = await fetch(
        `${API_URL}tasks?${queryParams.toString()}`,
        {
          method: "GET",
          headers: accessToken
            ? {
                "Content-Type": "application/json",
                Authorization: `Bearer ${accessToken}`,
              }
            : {
                "Content-Type": "application/json",
              },
        }
      );

      if (response.ok) {
        const data = await response.json();
        // console.log(data?.data?.tasks, 'datadata');
        let destuctData = data?.data?.tasks;
        let filtData = destuctData?.filter((item) => item?.id != taskId);
        filtData = filtData?.slice(0, 3);
        // console.log(filtData, 'datadata dfdf');
        setTasks(filtData || []); // Set tasks in state
      } else {
        console.error("Failed to fetch tasks:", response.statusText);
      }
    } catch (error) {
      console.error("Error occurred while fetching tasks:", error);
    }
  };

  const tokenImages = {
    ETH: "/assets/createtask/eth.svg",
    USDT: "/assets/createtask/usdtT.svg",
    USDC: "/assets/createtask/usdc.svg",
    LINK: "/assets/createtask/link.svg",
    PEPE: "/assets/createtask/pepe.svg",
    UNI: "/assets/createtask/uni.svg",
    DOP: "/assets/createtask/dop1.svg",
    WBTC: "/assets/createtask/wbtc.svg",
    Tomi: "/assets/createtask/tomi.svg",
  };

  useEffect(() => {
    getTasks({ limit: 5, offset: 1, categoryId });
    let userId = localStorage.getItem("userId");
    setUserId(userId);
  }, [categoryId, id]);

  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip " className="tolltipssss" {...props}>
      The task creator has time to review the submissions and decide on the
      winner
    </Tooltip>
  );

  return (
    <div className="similarcardsmain">
      <div className="custom-container paddzeroformbl">
        <div className="parentboxes">
          {tasks && tasks.length > 0 ? (
            tasks.map((item, idx) => {
              // Calculate task status using getStatus function
              const taskStatus = getStatus(item, "taskDetail");
              //   console.log("Task ID:", item?.id);
              //   console.log("Task Status:", taskStatus);
              //   console.log(
              //     "End Time Check:",
              //     new Date(item?.endTime) > new Date()
              //   );
              //   console.log(
              //     "User ID Check:",
              //     userId,
              //     item?.userId,
              //     userId != item?.userId
              //   );
              //   console.log("Participation Check:", !item?.hasParticipated);

              return (
                <div className="parent-box" key={idx}>
                  <div className="twomainbuttonsssssssss">
                    <div className="left">
                      <img
                        src="\assets\Frame2222.png"
                        alt="img"
                        className="img-fluid"
                      />
                      <p>
                        <TaskStatus taskData={item} />{" "}
                        <span>
                          {/* <OverlayTrigger
                            placement="right"
                            delay={{ show: 250, hide: 400 }}
                            overlay={renderTooltip}
                          >
                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" fill="none">
                              <path d="M6 1.625C5.03582 1.625 4.09329 1.91091 3.2916 2.44659C2.48991 2.98226 1.86507 3.74363 1.49609 4.63442C1.12711 5.52521 1.03057 6.50541 1.21867 7.45107C1.40678 8.39672 1.87108 9.26537 2.55286 9.94715C3.23464 10.6289 4.10328 11.0932 5.04894 11.2813C5.99459 11.4694 6.97479 11.3729 7.86558 11.0039C8.75637 10.6349 9.51775 10.0101 10.0534 9.20841C10.5891 8.40672 10.875 7.46418 10.875 6.5C10.8736 5.20749 10.3596 3.96831 9.44564 3.05436C8.5317 2.14042 7.29251 1.62636 6 1.625ZM5.8125 3.875C5.92375 3.875 6.03251 3.90799 6.12501 3.9698C6.21751 4.03161 6.28961 4.11946 6.33218 4.22224C6.37476 4.32502 6.3859 4.43812 6.36419 4.54724C6.34249 4.65635 6.28892 4.75658 6.21025 4.83525C6.13158 4.91391 6.03136 4.96749 5.92224 4.98919C5.81313 5.0109 5.70003 4.99976 5.59724 4.95718C5.49446 4.91461 5.40661 4.84251 5.3448 4.75001C5.28299 4.65751 5.25 4.54875 5.25 4.4375C5.25 4.28832 5.30927 4.14524 5.41475 4.03975C5.52024 3.93426 5.66332 3.875 5.8125 3.875ZM6.375 9.125C6.17609 9.125 5.98532 9.04598 5.84467 8.90533C5.70402 8.76468 5.625 8.57391 5.625 8.375V6.5C5.52555 6.5 5.43016 6.46049 5.35984 6.39017C5.28951 6.31984 5.25 6.22446 5.25 6.125C5.25 6.02554 5.28951 5.93016 5.35984 5.85984C5.43016 5.78951 5.52555 5.75 5.625 5.75C5.82392 5.75 6.01468 5.82902 6.15533 5.96967C6.29598 6.11032 6.375 6.30109 6.375 6.5V8.375C6.47446 8.375 6.56984 8.41451 6.64017 8.48484C6.71049 8.55516 6.75 8.65054 6.75 8.75C6.75 8.84946 6.71049 8.94484 6.64017 9.01517C6.56984 9.08549 6.47446 9.125 6.375 9.125Z" fill="#B4C2CD" />
                            </svg>
                          </OverlayTrigger> */}
                        </span>
                      </p>
                    </div>

                    {/* <SimilarTasksStatus taskData={item}/> */}

                    <div className="right">
                      <button>{category}</button>
                    </div>
                  </div>
                  <h4 className="parentboxhead">
                    {item?.title?.length > 20
                      ? item?.title?.slice(0, 20) + "..."
                      : item?.title}
                  </h4>
                  <div className="upper-area">
                    <div className="first-div">
                      <p>Participants</p>
                      <div className="multi-imgs">
                        <div className="imgs-parent">
                          {item?.participants?.slice(0, 4).map((e, i) => {
                            let classn;
                            if (i == 0) {
                              classn = "one";
                            } else if (i == 1) {
                              classn = "two";
                            } else if (i == 2) {
                              classn = "three";
                            } else {
                              classn = "four";
                            }
                            // if(i==3){
                            //     return
                            // }

                            return (
                              <img
                                key={i}
                                src={
                                  e?.user?.imageUrl
                                    ? e.user.imageUrl.startsWith("http")
                                      ? e.user.imageUrl
                                      : `https://${e.user.imageUrl}`
                                    : "/assets/edituploadimg.png"
                                }
                                alt="participantimg"
                                className="img-fluid"
                              />
                            );
                          })}
                          {/* <img src="\assets\dummy\profile.png" alt="img" className='img-fluid' />
                                      <img src="\assets\dummy\profile.png" alt="img" className='img-fluid' />
                                      <img src="\assets\dummy\profile.png" alt="img" className='img-fluid' />
                                      <img src="\assets\dummy\profile.png" alt="img" className='img-fluid' /> */}
                        </div>
                        {item?.participantCount > 4 && (
                          <span>{item?.participantCount - 4}</span>
                        )}
                        {item?.participantCount === "0" && (
                          <span>{item?.participantCount}</span>
                        )}
                      </div>
                    </div>
                    <div className="first-div">
                      <p>Created By</p>
                      <h6>
                        {item?.user?.imageUrl ? (
                          <img
                            src={item?.user?.imageUrl}
                            alt="img"
                            className="img-fluid"
                          />
                        ) : null}
                        {item?.user?.name ||
                          item?.user?.walletAddress?.slice(0, 5) +
                            "..." +
                            item?.user?.walletAddress?.slice(-4)}
                      </h6>
                    </div>
                    <div className="first-div">
                      <p>Reward</p>
                      <h6>
                        <img
                          src={tokenImages[item?.currencySymbol]}
                          alt={item?.currencySymbol}
                          srcSet=""
                        />{" "}
                        {item?.reward} {item?.currencySymbol}
                      </h6>
                    </div>
                    <div className="first-div">
                      <p>TX HASH</p>
                      <h6>
                        <a
                          target="_blank"
                          href={`${
                            item?.id > intitial_production_eth_id
                              ? Environment?.trxHashUrl_Arb
                              : Environment?.trxHashUrl
                          }/tx/${item?.taskTransactionHash}`}
                        >
                          {item?.taskTransactionHash?.slice(0, 5)}...
                          {item?.taskTransactionHash?.slice(-2)}
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="21"
                            viewBox="0 0 20 21"
                            fill="none"
                          >
                            <path
                              d="M8.33333 4.66667H6.83333C5.89991 4.66667 5.43285 4.66667 5.07633 4.84832C4.76273 5.00811 4.50795 5.2629 4.34816 5.5765C4.1665 5.93302 4.1665 6.40008 4.1665 7.3335V13.6668C4.1665 14.6003 4.1665 15.0667 4.34816 15.4232C4.50795 15.7368 4.76273 15.9921 5.07633 16.1519C5.43251 16.3333 5.899 16.3333 6.83059 16.3333H13.1691C14.1007 16.3333 14.5665 16.3333 14.9227 16.1519C15.2363 15.9921 15.4919 15.7366 15.6517 15.423C15.8332 15.0668 15.8332 14.6008 15.8332 13.6692V12.1667M16.6665 8V3.83334M16.6665 3.83334H12.4998M16.6665 3.83334L10.8332 9.66667"
                              stroke="black"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </a>
                      </h6>
                    </div>
                  </div>
                  <Timer endTime={item?.endTime} taskData={item} />
                  {/* onClick={handleShow} */}

                  {/* Updated participate button condition using taskStatus */}
                  {new Date(item?.endTime) > new Date() &&
                    userId != item?.userId &&
                    !item?.hasParticipated &&
                    taskStatus === "live" && (
                      <Link
                        to={`/similartaskdetail/${item?.id}`}
                        className="btn-part"
                      >
                        Participate
                      </Link>
                    )}
                </div>
              );
            })
          ) : (
            <h6 className="nodata-text">No task found!</h6>
          )}
        </div>
      </div>
    </div>
  );
}

export default SimilarTasks;
